/** Возвращает абсолютный HTTP- или HTTPS-адрес */
export const getHttpUrl = (value: string | null | undefined): string | null => {
    if (!value) return null;

    try {
        const url = new URL(value);

        return url.protocol === 'https:' || url.protocol === 'http:'
            ? url.href
            : null;
    } catch {
        return null;
    }
};
